// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visual-screen {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.visual-screen-left {
  width: 320px;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(7, 14, 35, 0.06), 0px 2px 8px -1px rgba(7, 14, 35, 0.05);
  height: calc(100vh - 3.5rem);
}
.visual-screen-right {
  width: calc(100% - 320px - 3rem);
  margin-top: 1.5rem;
  background: var(--white);
  border-radius: 0.5rem;
  box-shadow: 0px 1px 3px rgba(7, 14, 35, 0.06), 0px 2px 8px -1px rgba(7, 14, 35, 0.05);
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  height: calc(100vh - 3.5rem - 1.5rem - 1.5rem);
  position: relative;
}
.visual-screen-right iframe {
  height: 100%;
  width: 100%;
}

.visual-loader {
  display: flex;
  opacity: 1;
  z-index: 99999999;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: opacity 1s ease-in;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
.visual-loader-wrapper {
  padding: 1rem 0;
}
.visual-loader-text {
  margin-top: 1rem;
  color: #777F89;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.visual-loader-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 68px;
  height: 68px;
  margin: 0 auto;
  position: relative;
}
.visual-loader-paylixecommerce {
  position: absolute;
}
.visual-loader :root {
  --loader-bg-stroke: #343434;
  --loader-trace-stroke: #343434;
}
html.dark .visual-loader {
  --loader-bg-stroke: #FFFFFF;
  --loader-trace-stroke: #FFFFFF;
}
.visual-loader .animate-trace {
  animation: trace 3s linear infinite;
  stroke-dasharray: 3000;
}
@keyframes trace {
  0% {
    stroke-dasharray: 3000;
    stroke-dashoffset: 6000;
    opacity: 0.9;
  }
  100% {
    stroke-dasharray: 3000;
    stroke-dashoffset: 0;
    opacity: 0.9;
  }
}

.themes-buttons-dropdown {
  min-width: 240px;
  max-width: 240px;
  width: 100%;
  background: var(--white);
  border-radius: 0.5rem;
  box-shadow: 0 4px 24px -4px rgba(18, 20, 23, 0.08);
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
}
.themes-buttons-dropdown button {
  width: 100%;
  border: none;
  margin: 0 !important;
  box-shadow: none !important;
  align-items: center;
  justify-content: flex-start;
}
.themes-buttons-dropdown button.delete-icon {
  color: var(--red6);
}
.themes-buttons-dropdown button.delete-icon svg * {
  stroke: var(--red6);
}
.themes-buttons-dropdown button.delete-icon:hover {
  background: var(--red0);
}
.themes-buttons-dropdown button svg {
  margin-right: 0.5rem;
}
.themes-buttons-dropdown button:hover {
  background: var(--black1);
}
.themes-buttons-dropdown button:hover img {
  display: block;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/builder/screens/visual/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AACF;AACE;EACE,YAAA;EACA,wBAAA;EACA,qFAAA;EACA,4BAAA;AACJ;AAEE;EACE,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,qFAAA;EACA,oBAAA;EACA,qBAAA;EACA,8CAAA;EACA,kBAAA;AAAJ;AAEI;EACE,YAAA;EACA,WAAA;AAAN;;AAKA;EACE,aAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAFF;AAIE;EACE,eAAA;AAFJ;AAIE;EACE,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAFJ;AAIE;EACE,kBAAA;AAFJ;AAME;EACE,2BAAA;EACA,8BAAA;AAJJ;AAQE;EACE,2BAAA;EACA,8BAAA;AANJ;AAUE;EACE,mCAAA;EACA,sBAAA;AARJ;AAWE;EACE;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;EATJ;EAWE;IACE,sBAAA;IACA,oBAAA;IACA,YAAA;EATJ;AACF;;AAcA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,kDAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAXF;AAaE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;AAXJ;AAaI;EACE,kBAAA;AAXN;AAYM;EACE,mBAAA;AAVR;AAYM;EACE,uBAAA;AAVR;AAcI;EACE,oBAAA;AAZN;AAeI;EACE,yBAAA;AAbN;AAeM;EACE,cAAA;AAbR","sourcesContent":[".visual-screen {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n\n  &-left {\n    width: 320px;\n    background: var(--white);\n    box-shadow: 0px 1px 3px rgba(7, 14, 35, 0.06), 0px 2px 8px -1px rgba(7, 14, 35, 0.05);\n    height: calc(100vh - 3.5rem);\n  }\n\n  &-right {\n    width: calc(100% - 320px - 3rem);\n    margin-top: 1.5rem;\n    background: var(--white);\n    border-radius: 0.5rem;\n    box-shadow: 0px 1px 3px rgb(7 14 35 / 6%), 0px 2px 8px -1px rgb(7 14 35 / 5%);\n    margin-right: 1.5rem;\n    margin-bottom: 1.5rem;\n    height: calc(100vh - 3.5rem - 1.5rem - 1.5rem);\n    position: relative;\n\n    iframe {\n      height: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.visual-loader {\n  display: flex;\n  opacity: 1;\n  z-index: 99999999;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 1s ease-in;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  &-wrapper {\n    padding: 1rem 0;\n  }\n  &-text {\n    margin-top: 1rem;\n    color: #777F89;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n  }\n  &-circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 100%;\n    width: 68px;\n    height: 68px;\n    margin: 0 auto;\n    position: relative;\n  }\n  &-paylixecommerce {\n    position: absolute;\n  }\n\n  // Theme-responsive loader colors\n  :root {\n    --loader-bg-stroke: #343434;\n    --loader-trace-stroke: #343434;\n  }\n\n  // Dark theme - whiter loader\n  html.dark & {\n    --loader-bg-stroke: #FFFFFF;\n    --loader-trace-stroke: #FFFFFF;\n  }\n\n  // Trace animation for new Paylix loader\n  .animate-trace {\n    animation: trace 3s linear infinite;\n    stroke-dasharray: 3000;\n  }\n\n  @keyframes trace {\n    0% {\n      stroke-dasharray: 3000;\n      stroke-dashoffset: 6000;\n      opacity: 0.9;\n    }\n    100% {\n      stroke-dasharray: 3000;\n      stroke-dashoffset: 0;\n      opacity: 0.9;\n    }\n  }\n\n}\n\n.themes-buttons-dropdown {\n  min-width: 240px;\n  max-width: 240px;\n  width: 100%;\n  background: var(--white);\n  border-radius: .5rem;\n  box-shadow: 0 4px 24px -4px rgb(18 20 23 / 8%);\n  padding: .5rem;\n  display: flex;\n  flex-direction: column;\n\n  button {\n    width: 100%;\n    border: none;\n    margin: 0 !important;\n    box-shadow: none !important;\n    align-items: center;\n    justify-content: flex-start;\n\n    &.delete-icon {\n      color: var(--red6);\n      svg * {\n        stroke: var(--red6);\n      }\n      &:hover {\n        background: var(--red0);\n      }\n    }\n\n    svg {\n      margin-right: .5rem;\n    }\n\n    &:hover {\n      background: var(--black1);\n\n      img {\n        display: block;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
